// src/services/userService.js
import { db, auth } from "../firebase/firebaseConfig";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

// 🔹 Get User Profile
export const getUserProfile = async (userId) => {
    const docRef = doc(db, "users", userId);
    const docSnap = await getDoc(docRef);
    return docSnap.exists() ? docSnap.data() : null;
};

// 🔹 Update User Profile
export const updateUserProfile = async (userId, profileData) => {
    const docRef = doc(db, "users", userId);
    await setDoc(docRef, profileData, { merge: true });
};

// 🔹 Upload Profile Picture
export const uploadProfilePicture = async (file) => {
    const storage = getStorage();
    const user = auth.currentUser;
    if (!user) throw new Error("User not authenticated");

    const fileRef = ref(storage, `profilePictures/${user.uid}`);
    await uploadBytes(fileRef, file);
    return await getDownloadURL(fileRef);
};
